import React from "react";

const ContentLayout = ({
  header,
  children,
  className = "",
  headerClassName = "",
  bodyClassName = "",
  bodyVariant = "white", // Default variant for the body
}) => {
  const bodyClasses = `${bodyClassName} content_layout_body ${
    bodyVariant === "white" ? "white" : "transparent"
  }`;

  return (
    <div className={`content_layout ${className}`}>
      {/* Header Section */}
      {header && (
        <div className={`content_layout_header ${headerClassName}`}>
          {header}
        </div>
      )}

      {/* Body Section */}
      {children && <div className={bodyClasses}>{children}</div>}
    </div>
  );
};

export default ContentLayout;
